module.exports = __webpack_public_path__ + "static/img/03-北京学校1.e9b0df9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schoolImg/03-北京学校1.png
// module id = xRT3
// module chunks = 0